import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { ArrowUpRight } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DirectoryList = () => {
  const [sites, setSites] = useState([]);

  useEffect(() => {
    axios.get(`${API}/directory`).then((res) => setSites(res.data)).catch(() => {});
  }, []);

  const grouped = useMemo(() => {
    const order = [];
    const map = {};
    sites.forEach((site) => {
      if (!map[site.category]) {
        map[site.category] = [];
        order.push(site.category);
      }
      map[site.category].push(site);
    });
    let counter = 0;
    return order.map((category) => ({
      category,
      items: map[category].map((site) => ({ ...site, index: ++counter })),
    }));
  }, [sites]);

  if (!sites.length) return null;

  return (
    <div className="mt-12 pt-8 border-t border-white/10" data-testid="directory-list">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
        <h2 className="text-2xl text-white" style={{ fontFamily: "Unbounded, sans-serif" }}>
          The 70 platforms
        </h2>
        <span className="stats-chip" data-testid="directory-count">{sites.length} sites</span>
      </div>

      <div className="space-y-8">
        {grouped.map((group) => (
          <div key={group.category} data-testid={`directory-group-${group.category.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <div className="text-xs uppercase tracking-widest text-[#D9F839] mb-3" style={{ fontFamily: "Unbounded, sans-serif" }}>
              {group.category}
            </div>
            <div className="grid gap-2">
              {group.items.map((site) => (
                <div
                  className="flex items-center gap-4 bg-[#0E0E14] border border-white/10 rounded-2xl px-4 py-3 transition-colors hover:border-[#D9F839]/40"
                  key={site.id}
                  data-testid={`directory-row-${site.index}`}
                >
                  <span className="text-xs text-[#7A7A85] w-7 shrink-0 tabular-nums">{site.index}.</span>
                  <span className="text-white text-sm flex-1 min-w-0 truncate">{site.name}</span>
                  <a
                    href={site.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cta-button rounded-full px-4 py-2 text-xs inline-flex items-center gap-1.5 shrink-0"
                    data-testid={`directory-button-${site.index}`}
                  >
                    {site.button_label || "Visit site"} <ArrowUpRight size={13} weight="bold" />
                  </a>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DirectoryList;
